import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Button from 'components/button';
import { AccountSummary, UserDetail } from 'types/users';
import { ImpersonateContainer } from './ImpersonateNotice.styles';

const ImpersonateNotice = ({
  user,
  account,
  onClose,
}: {
  user: UserDetail;
  account: AccountSummary;
  onClose(): void;
}): JSX.Element => {
  const label = isMobile ? 'Impersonated as' : 'You are impersonated as';

  return (
    <ImpersonateContainer>
      <p>
        {label}
        <Link
          to={`/user/${user?.id}`}
        >{` ${user?.uaa_data?.profile?.data?.first_name} ${user?.uaa_data?.profile?.data?.last_name}`}</Link>
        , {user?.uaa_data?.roles?.data?.[0].name}.
        <Link to={`/account/${account?.id}`}>{` ${account?.name}`}</Link>
      </p>
      <Button $primary size={'small'} onClick={onClose}>
        Stop impersonate
      </Button>
    </ImpersonateContainer>
  );
};

export default ImpersonateNotice;
